import React, { useEffect, useState } from 'react';
import { WEBSITE } from '../Utilities/Config';

import '../Styles/HoverTooltip.css';

export default function HoverTooltip(props) {

	const { data, mousePosition, hoverTooltipVisible, setHoverTooltipVisible, language } = props;
	const [text, setText] = useState(null);
	const [subText, setSubText] = useState(null);
	const [image, setImage] = useState(null);

	useEffect(() => {
		if (!data || !language) setHoverTooltipVisible(false);

		setSubText((data?.content?.properties?.name) ? data.content.properties.name : null);

		setImage((data?.content?.properties?.img) ? {
			url: data.content.properties.img,
			attrib: data.content.properties.img_attrib,
		} : null);

		if (data.id && language) {
			const description = language[`layers:title:${data.id}`];
			setText(description);
			setHoverTooltipVisible(true);
		} else {
			setHoverTooltipVisible(false);
		}

	}, [data, setHoverTooltipVisible, language]);

	const subTextCode = subText ? <span className='sub-text'> ({subText})</span> : '';

	return (
		<>
			{hoverTooltipVisible &&
				<div
					className={hoverTooltipVisible ? 'hover-tooltip-wrapper show': 'hover-tooltip-wrapper'}
					style={
						hoverTooltipVisible && {
							left: mousePosition.left,
							top: mousePosition.top
						}
					}
				>
					{image && <div className='image-block'>
						<img alt='' className='image' src={`${WEBSITE}/photos/${image.url}`}/>
						<div className='attrib'>{image.attrib}</div>
					</div>}
					<div className='text'>{text}{subTextCode}</div>
				</div>
			}
		</>
	);

};
